import { render, staticRenderFns } from "./m_invest021.vue?vue&type=template&id=0b763e4d&scoped=true&"
import script from "./m_invest021.vue?vue&type=script&lang=js&"
export * from "./m_invest021.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b763e4d",
  null
  
)

export default component.exports